import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

const BookingCancelPage = () => (
  <div data-testid="booking-cancel-page">
    <Navigation />
    <div className="min-h-screen pt-32 pb-20 bg-background">
      <div className="container-x">
        <div className="max-w-2xl mx-auto bg-white border border-border p-10 md:p-14 text-center">
          <XCircle size={42} className="text-destructive mx-auto" />
          <div className="overline mt-6">Payment Cancelled</div>
          <h1 className="font-serif text-3xl md:text-4xl text-primary mt-3 text-balance">
            Your booking wasn&rsquo;t completed
          </h1>
          <p className="text-muted-foreground mt-3">No charge was made. Your dates are still available — try again whenever you&rsquo;re ready.</p>
          <div className="flex gap-3 justify-center mt-6">
            <Link to="/book" className="btn-primary">Try booking again</Link>
            <Link to="/" className="btn-outline">Back home</Link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default BookingCancelPage;
